<template>
  <Modal
    :value="value"
    @hide="hide()"
    title="License"
    :subtitle="computer.name"
  >
    <template v-if="serverLicense" slot="body" class="content">
      <div class="tags has-addons">
        <span class="tag is-rounded  is-light">Status</span>
        <span
          class="tag is-rounded "
          :class="
            computer.license && computer.license.active
              ? 'is-success'
              : 'is-danger'
          "
        >
          {{
            computer.license && !computer.license.active
              ? "License is deactivated"
              : !computer.license
              ? "No assigned license"
              : "Active"
          }}
        </span>
      </div>

      <div class="tags has-addons is-inline ">
        <span class="tag  is-light">Free</span>
        <span
          class="tag "
          :class="serverLicense.free <= 0 ? 'is-danger' : 'is-success'"
          >{{ serverLicense.free }}</span
        >
      </div>

      <div class="tags  has-addons margin-left-10 is-inline">
        <span class="tag  is-light">Total</span>
        <span class="tag  is-info">{{ serverLicense.total }}</span>
      </div>
    </template>
    <template slot="footer" class="content">
      <div v-if="!isLoading">
        <button
          v-if="!computer.license || !computer.license.active"
          @click="add()"
          class="button is-primary"
          :disabled="serverLicense.free <= 0"
        >
          {{
            computer.license && computer.license.active
              ? "Activate license"
              : "Assign license"
          }}
        </button>

        <button
          v-if="computer.license && computer.license.active"
          @click="remove()"
          class="button is-danger"
        >
          Remove license
        </button>
        <button class="button" @click="hide()">Close</button>
      </div>
      <div v-show="isLoading" class="spinner-wrapper center">
        <span class="spinner is-centered"></span>
      </div>
    </template>
  </Modal>
</template>
<script>
import { postApi } from "@/utils/http";

export default {
  props: {
    value: Boolean,
    computer: Object,
  },
  components: {
    Modal: () => import("@/components/main/Modal.vue"),
  },
  data() {
    return {
      isLoading: false,
      serverLicense: null,
    };
  },
  async created() {
    await this.reloadGlobalLicense(true);
    await this.getGlobalLicense();
  },
  methods: {
    async add() {
      if (!this.isLoading) {
        this.isLoading = true;
        const res = await postApi("set/computerLicense", {
          domainUID: this.$route.params.domainUID,
          computerUID: this.computer.uid,
        });

        this.$store.commit("computer/mergeComputer", {
          c: this.computer,
          obj: { license: res[0] },
        });

        this.computer.license = res[0];

        await this.getGlobalLicense();

        this.isLoading = false;
      }
    },
    async remove() {
      if (!this.isLoading) {
        this.isLoading = true;
        const res = await postApi("delete/computerLicense", {
          domainUID: this.$route.params.domainUID,
          computerUID: this.computer.uid,
        });

        this.$store.commit("computer/mergeComputer", {
          c: this.computer,
          obj: { license: null },
        });

        this.computer.license = null;

        await this.getGlobalLicense();

        this.isLoading = false;
      }
    },

    async getGlobalLicense() {
      try {
        this.isLoading = true;
        const res = await postApi("get/serverLicense", {});
        this.serverLicense = res;
        this.isLoading = false;
      } catch (e) {
        if (e.response.status === 500)
          this.$helpers.notify("Error", "Internal server error.", "danger");
        else {
          this.$helpers.notify("Error", "Unknown error.", "danger");
        }
      }
    },

    async reloadGlobalLicense(skipMessage) {
      try {
        this.isLoading = true;
        const res = await postApi("reload/serverLicense", {});
        this.serverLicense = res;
        this.isLoading = false;

        if (!skipMessage) {
          this.$helpers.notify(
            "Success",
            "The global license has been updated."
          );
        }
      } catch (e) {
        if (e.response.status === 500)
          this.$helpers.notify("Error", "Internal server error.", "danger");
        else {
          this.$helpers.notify("Error", "Unknown error.", "danger");
        }
      }

      await this.$store.dispatch("computer/fetch", {
        domainUID: this.$route.params.domainUID,
        force: true,
      });
    },

    hide() {
      if (!this.isLoading) {
        this.$emit("hide", false);
        this.$emit("input", false);
      }
    },
  },
};
</script>
